export const mallaMetaMgilp = {
  ejes: [
    {
      id: "fundamentos_proceso_educativo",
      label: "Fundamentos del proceso educativo",
      row: 1,
      color: "#B8D4E8",
      textColor: "#1A1A1A",
    },
    {
      id: "procesos_gestion_institucional",
      label: "Procesos de gestión institucional",
      row: 2,
      color: "#F5E6A8",
      textColor: "#1A1A1A",
    },
    {
      id: "evaluacion_investigacion_intervencion",
      label: "Evaluación, investigación, intervención e innovación",
      row: 3,
      color: "#C5E0B4",
      textColor: "#1A1A1A",
    },
  ],
  semestres: [1, 2, 3, 4],
  subtotalesPorSemestre: {
    HBCA: 192,
    HTI: 160,
    Creditos: 22,
  },
};
